import { Component, HostListener } from '@angular/core';
import emailjs, { type EmailJSResponseStatus } from '@emailjs/browser';

@Component({
  selector: 'app-home-five',
  templateUrl: './home-five.component.html',
  styleUrl: './home-five.component.css'
})
export class HomeFiveComponent {
  //header
  lastScrollTop = 0;
  isHidden = false;
  isMenuOpen = false;

  // Gallery data
  galleryItems = [
    { id: 1, imageUrl: 'assets/images/portfolio/gallery-sm-1.jpg', title: 'Gallery Image 1', alt: 'gallery-1' },
    { id: 2, imageUrl: 'assets/images/portfolio/gallery-sm-2.jpg', title: 'Gallery Image 2', alt: 'gallery-2' },
    { id: 3, imageUrl: 'assets/images/portfolio/gallery-sm-3.jpg', title: 'Gallery Image 3', alt: 'gallery-3' },
    { id: 4, imageUrl: 'assets/images/portfolio/gallery-sm-4.jpg', title: 'Gallery Image 4', alt: 'gallery-4' },
    { id: 5, imageUrl: 'assets/images/portfolio/gallery-sm-5.jpg', title: 'Gallery Image 5', alt: 'gallery-5' },
    { id: 6, imageUrl: 'assets/images/portfolio/gallery-sm-6.jpg', title: 'Gallery Image 6', alt: 'gallery-1' },
    { id: 7, imageUrl: 'assets/images/portfolio/gallery-sm-7.jpg', title: 'Gallery Image 7', alt: 'gallery-7' },
    { id: 8, imageUrl: 'assets/images/portfolio/gallery-sm-8.jpg', title: 'Gallery Image 8', alt: 'gallery-8' },
    { id: 9, imageUrl: 'assets/images/portfolio/gallery-sm-9.jpg', title: 'Gallery Image 9', alt: 'gallery-9' },
    { id: 10, imageUrl: 'assets/images/portfolio/gallery-sm-10.jpg', title: 'Gallery Image 10', alt: 'gallery-10' },
    { id: 11, imageUrl: 'assets/images/portfolio/gallery-sm-11.jpg', title: 'Gallery Image 11', alt: 'gallery-1' },
    { id: 12, imageUrl: 'assets/images/portfolio/gallery-sm-12.jpg', title: 'Gallery Image 12', alt: 'gallery-12' },
  ];

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  closeMenu() {
    this.isMenuOpen = false;
  }


  @HostListener('window:scroll', [])
  onScroll(): void {

    const skillsSection = document.querySelector('.skill');
    
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

    // Check scroll direction
    if (currentScroll > this.lastScrollTop && currentScroll > 100) {
      // Scrolling down
      this.isHidden = true;
    } else {
      // Scrolling up
      this.isHidden = false;
    }

    this.lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; 
  }

  // ScrollToSection
  scrollToSection(sectionId: string) {
    const element = document.getElementById(sectionId);
    if (element) {
      const yOffset = -80; 
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }

  // Open lightbox gallery
  openLightbox(index: number): void {
    console.log('Opening lightbox at index:', index);
    
    // Remove any existing lightbox
    const existingLightbox = document.getElementById('lightbox-overlay');
    if (existingLightbox) {
      existingLightbox.remove();
    }
    
    const lightboxOverlay = document.createElement('div');
    lightboxOverlay.className = 'lightbox-overlay';
    lightboxOverlay.id = 'lightbox-overlay';
    
    const lightboxContainer = document.createElement('div');
    lightboxContainer.className = 'lightbox-container';
    
    let currentIndex = index;
    const self = this;
    
    const updateImage = () => {
      const item = self.galleryItems[currentIndex];
      lightboxContainer.innerHTML = `
        <div class="lightbox-content">
          <button class="lightbox-close" type="button" aria-label="Close lightbox">×</button>
          <button class="lightbox-prev" type="button" aria-label="Previous image">❮</button>
          <img src="${item.imageUrl}" alt="${item.alt}">
          <button class="lightbox-next" type="button" aria-label="Next image">❯</button>
          <div class="lightbox-caption">${item.title}</div>
        </div>
      `;
      
      // Re-attach event listeners after innerHTML update
      const closeBtn = lightboxContainer.querySelector('.lightbox-close') as HTMLElement;
      const prevBtn = lightboxContainer.querySelector('.lightbox-prev') as HTMLElement;
      const nextBtn = lightboxContainer.querySelector('.lightbox-next') as HTMLElement;
      
      closeBtn?.addEventListener('click', () => {
        console.log('Close button clicked');
        lightboxOverlay.remove();
      });
      
      prevBtn?.addEventListener('click', (e: Event) => {
        e.stopPropagation();
        console.log('Previous button clicked');
        currentIndex = (currentIndex - 1 + self.galleryItems.length) % self.galleryItems.length;
        updateImage();
      });
      
      nextBtn?.addEventListener('click', (e: Event) => {
        e.stopPropagation();
        console.log('Next button clicked');
        currentIndex = (currentIndex + 1) % self.galleryItems.length;
        updateImage();
      });
    };
    
    updateImage();
    lightboxOverlay.appendChild(lightboxContainer);
    document.body.appendChild(lightboxOverlay);
    console.log('Lightbox added to DOM');
    
    // Close on overlay click (outside image)
    lightboxOverlay.addEventListener('click', (e: Event) => {
      if (e.target === lightboxOverlay) {
        console.log('Overlay clicked, closing lightbox');
        lightboxOverlay.remove();
      }
    });
    
    // Close on Escape key
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        console.log('Escape pressed, closing lightbox');
        lightboxOverlay.remove();
        document.removeEventListener('keydown', handleEscape);
      }
    };
    
    document.addEventListener('keydown', handleEscape);
  }

  // Contact Form
  formData = {
    user_name: '',
    user_email: '',
    message: ''
  };

  // EmailJS service configuration
  private serviceId = 'helifax-form';  // Replace with your EmailJS Service ID
  private templateId = 'helifax-form';  // Replace with your EmailJS Template ID
  private publicKey = 'dOfh1ImCGDZCO9GJb';  // Replace with your EmailJS Public Key

  // Method to send email on form submission
  public sendEmail(event: Event): void {
    event.preventDefault();

    // Send email using EmailJS
    emailjs.sendForm(this.serviceId, this.templateId, event.target as HTMLFormElement, this.publicKey)
      .then(
        (response: EmailJSResponseStatus) => {
          alert('Message sent successfully. Thank you, we will get back to you soon!');
          this.resetForm();
        },
        (error: EmailJSResponseStatus) => {
          console.error('Failed to send message. Error:', error.text);
          alert('Failed to send the message. Please try again later.');
        }
      );
  }

  // Method to reset the form after submission
  private resetForm(): void {
    this.formData = {
      user_name: '',
      user_email: '',
      message: ''
    };
  }
}
